export const QUERY_PARAMS_TO_REMOVE: string[] = [
  'sector',
  'industry',
  'leagueType',
  'viewId',
  'companyName',
  'routeType',
  'tab',
  'productType',
  'articleType',
  'bondType',
];
